"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CategorySelectMenuGlobalStyles = exports.StyledSearchInput = exports.StyledSaveButton = exports.StyledWrapper = void 0;
const ui_components_1 = require("@groupby/ui-components");
const styled_components_1 = __importStar(require("styled-components"));
exports.StyledWrapper = styled_components_1.default.div `
  display: flex;
  align-items: center;
  height: 100%;
  width: 100%;
  gap: 0.5rem;
  padding: 4px 8px;
  box-sizing: border-box;

  .category-select {
    height: 2.4rem;
    flex: 1 1 auto;
    min-width: 0;

    .MuiFormControl-root {
      height: 100%;
    }
  }
`;
exports.StyledSaveButton = (0, styled_components_1.default)(ui_components_1.ButtonV2) `
  height: 2.4rem !important;
  flex: 0 0 3.8rem;
  flex-shrink: 0;
  margin-left: 0.5rem;
`;
exports.StyledSearchInput = (0, styled_components_1.default)(ui_components_1.TextField) `
  width: 100%;
  height: 2.4rem;

  .MuiInputBase-root {
    height: 100%;
    font-size: 0.875rem;
    
    .MuiInputBase-input {
      padding: 8px 12px !important;
    }
  }
  
  /* Simplified border styling */
  .MuiOutlinedInput-notchedOutline {
    border-color: rgba(0, 0, 0, 0.23);
  }
  
  &:hover .MuiOutlinedInput-notchedOutline {
    border-color: rgba(0, 0, 0, 0.87);
  }
  
  &.Mui-focused .MuiOutlinedInput-notchedOutline {
    border-color: #1976d2;
    border-width: 2px;
  }
`;
// Global styles for the portaled menu - uses unique className to avoid conflicts
exports.CategorySelectMenuGlobalStyles = (0, styled_components_1.createGlobalStyle) `
  /* Target the specific menu by its unique className */
  .category-select-menu {
    .MuiMenu-paper.MuiMenu-paper {
      max-height: 300px;
      width: 340px;
      /* Ensure proper z-index for DataGrid context */
      z-index: 1300;
    }

    .MuiList-root {
      padding-top: 55px;
    }

    .search-input-wrapper {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      background: white;
      padding: 8px;
      z-index: 1;
      box-sizing: border-box;
    }
  }
`;
